import * as React from 'react';
import Menu from '@mui/material/Menu';
import { Box, IconButton } from '@mui/material';
import { arrayRemove, arrayUnion, doc, updateDoc } from 'firebase/firestore';
import { IMessage } from 'interfaces/message.interface';
import { db } from 'app/firebase';
import { useAppSelector } from 'app/hooks';
import { selectAuth } from 'features/auth/authSlice';
import Emoji from './Emoji';

type IReactionBar = {
  children: React.ReactNode;
  messages: IMessage[];
  msgId: string;
  docRef: string;
  reaction?: string[];
  handleCloseParent: () => void;
};

 const ReactionBar:React.FC<IReactionBar> = ({
  children,
  messages,
  msgId,
  docRef,
  reaction,
  handleCloseParent,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const authState = useAppSelector(selectAuth);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    handleCloseParent();
  };

  const handleReaction = async () => {
    try {
      if (reaction) {
        if (authState.username && reaction.length > 0) {
          if (reaction.includes(`${authState.username}`)) {
            await updateDoc(doc(db, 'chats', docRef, 'messages', msgId), {
              reaction: arrayRemove(authState.username),
            });
          } else {
            await updateDoc(doc(db, 'chats', docRef, 'messages', msgId), {
              reaction: arrayUnion(`${authState.username}-`),
            });
          }
          handleClose();
        } else {
          await updateDoc(doc(db, 'chats', docRef, 'messages', msgId), {
            reaction: [authState.username],
          });
        }
      } else {
        await updateDoc(doc(db, 'chats', docRef, 'messages', msgId), {
          reaction: [authState.username],
        });
      }
      handleClose()
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div>
      <span
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
      >
        {children}
      </span>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <Box sx={{ display: 'flex', gap: '10px', padding: '5px 15px' }}>
          <IconButton color="inherit" size="small" onClick={handleReaction}>
            <Emoji symbol={'0x1F60A'} label='happy' />
          </IconButton>
        </Box>
      </Menu>
    </div>
  );
}


export default ReactionBar;